import { tokenKeyName } from '../constants';

const isClient = typeof localStorage !== 'undefined';
export function setSession(accessToken: string | null | undefined) {
  if (isClient) {
    if (accessToken) localStorage.setItem(tokenKeyName, accessToken);
    else localStorage.removeItem(tokenKeyName);
  }
}
